import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PublicListingService } from '../services/listing/public-listing.service';

/**
 * Resolver to pre-fetch product details (yachts or merchandise) before component rendering.
 * Required for SSR to populate meta tags in the initial HTML response.
 */
export const ProductDetailResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot
): Observable<any> => {
  const service = inject(PublicListingService);
  const idStr = route.paramMap.get('id');

  if (!idStr) {
    return of(null);
  }

  const productId = parseInt(idStr, 10);
  const path = route.routeConfig?.path || '';

  if (path.includes('boats')) {
    return service.getBoatProductDetails(productId);
  }

  if (path.includes('merchandise')) {
    return service.getMerchProductDetails(productId);
  }

  return of(null);
};
